export default "__VITE_ASSET__hEpFQJbc__"